import moment from 'moment'

// Ensures that we have a useable value for the calendar
// Must be either a VALID MomentJS object, or stricly undefined.
export const parseDateForMonth = (date) => {
  if (!date) return undefined

  if (date._isValid === false) return undefined
  if (date._isValid === true) return date

  const newDate = new Date(date)
  const newMoment = moment(newDate)
  if (newMoment._isValid) return newMoment

  return undefined
}

const helpers = {
  parseDateForMonth,
}

export default helpers
